import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { KeyValues10, KeyValues3, KeyValues5, LocalService, Paging, StatusWithId, Wrappers5 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class B2bService {
  private controllerName = service_controllers_methods.b2b.controller;
  private methods = service_controllers_methods.b2b.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public saveB2bAccount(data: KeyValues10): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveB2bAccount, body);
  }

  public saveB2bOwner(b2bAccountId: string, contactNumber: string): Observable<StatusWithId> {
    const body = {
      sel: this.localService.getSelected(),
      dt: {
        v1: b2bAccountId,
        v2: contactNumber
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveB2bOwner, body);
  }

  public getB2bAccounts(paging?: Paging): Observable<Wrappers5> {
    const body = {
      sel: this.localService.getSelected(),
      dt: {} as KeyValues5,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetB2bAccounts, body);
  }

  public getB2bAccount(id: string): Observable<KeyValues10> {
    const body = {
      sel: this.localService.getSelected(),
      dt: {
        v1: id
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetB2bAccount, body);
  }

  public getB2bOwners(b2bAccountId: string, isActive: boolean): Observable<KeyValues5[]> {
    const body = {
      sel: this.localService.getSelected(),
      dt: {
        v1: b2bAccountId,
        v2: isActive ? '1' : '0'
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetB2bOwners, body);
  }
}
